import type { DynamoDBResourceSection } from '@root/@types/database';

import { isSummarySection } from './is-summary-section';

export const hasSummarySections = (sections: Pick<DynamoDBResourceSection, 'sk'>[]): boolean =>
  sections.some(isSummarySection);
